import { axiosInstance } from '../Middleware'
import { AvancementsEchelonAgentType, MethodesAvancementsAgentType } from './types'

export class CarriereApi {
  public static loadAvancementsEchelon = (identifiantAgent: number) : Promise<AvancementsEchelonAgentType> =>
    axiosInstance.get(`/personnel/personnel/agents/${identifiantAgent}/avancementsEchelon`)
      .then(response => response.data)

  public static loadMethodesAvancements = (identifiantAgent: number) : Promise<MethodesAvancementsAgentType> =>
    axiosInstance.get(`/personnel/personnel/agents/${identifiantAgent}/methodesAvancements`)
      .then(response => response.data)
}
